import axios from 'axios';
import { baseUrl } from '../utils/constants';

export const CAPS_PAYROLL_PROVIDER_ID = 1;
export const MEDIA_SERVICES_PAYROLL_PROVIDER_ID = 2;
export const INVOICE_ID = 3;
export const REVOLUTION_PAYROLL_PROVIDER_ID = 4;
export const STARTING_PAPERWORK_ID = 5;
export const EXTREME_PAYROLL_PROVIDER_ID = 6;


export const getPayrollProviderName = (id) => {
  const mapping = [
    "CAPS",
    "Media Services",
    "Invoice",
    "Revolution",
    "Starting Paperwork",
    "Extreme"
  ]
  return mapping[id - 1]
}

export const getPayrollProviders = async (page = 1, pageSize = 10) => axios.get(
  `${baseUrl()}r/payroll-providers/?page=${page}&pageSize=${pageSize}`, { withCredentials: true },
);
